// extracted by mini-css-extract-plugin
export default {"readmeContainer":"readme_readmeContainer__XWpHo","sectionContainer":"readme_sectionContainer__TehC9"};